import React, { useState } from "react"
import { Link } from "gatsby"
import { slide as Menu } from 'react-burger-menu'
//import useScrollLock from '../../custom/use-scroll-lock'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { device } from '../device'

import Div100vh from 'react-div-100vh'
import styled from "styled-components"
import font from "../../fonts/fonts.module.scss"

import { Button } from "../buttons"

import logo from '../../images/logos/saven_logo.svg'
import logoBrown from '../../images/logos/saven_logo_brown.svg'
import link from "../../images/social/link-dark.svg"
import face from "../../images/social/face-dark.svg"
import insta from "../../images/social/insta-dark.svg"
import menuIcon from '../../images/mobile-filter-menu.svg'
import menuIconWhite from '../../images/mobile-filter-menu-white.svg'

const Sidebar = ({ white, types, changeFilter }) => {
  const {t} = useTranslation()

  const [ sidebarOpen, setSidebarOpen ] = useState(false)
  //const [ lock, setLock ] = useState(false)
  const [filter, setFilter] = useState(0);

  //useScrollLock(lock)

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
    //setLock(!lock)
  }  

  function change(i, type) {
    if(i !== filter){
      changeFilter(type);
      setFilter(i);
    }
    else{
      changeFilter("none");
      setFilter(0);
    }
  }
  
  return(
    <StyledBar white={white}>
      <div className='header header-bg' style={{backgroundColor: sidebarOpen ? '#1d252c' : '#fff'}}>
        <button className='btn-header' onClick={toggleSidebar}>
          <div className="hamburguer-icon">
            <div><img src={sidebarOpen ? menuIconWhite : menuIcon} alt="wine-menu-icon" className="wine-menu-icon"/></div>
          </div>
        </button>
      </div>
      <Menu 
        customBurgerIcon={false}
        isOpen={sidebarOpen}
        width={'100%'}
        noOverlay
        right
      >
        {changeFilter && 
        <div className='first-container'>
          <p className={font.aGGD + " menuTitle"}>{t('sidebar:vinhos.titleFilter')}</p>
            <div className="selector">
              {types.vb && <Button filterSelection className={filter===1 ? "selec filterBtn" : "filterBtn"} onClick={() => change(1, "Vinho Branco")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.branco')}</h4></Button>}
              {types.vt && <Button filterSelection className={filter===2 ? "selec filterBtn" : "filterBtn"} onClick={() => change(2, "Vinho Tinto")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.tinto')}</h4></Button>}
              {types.vr && <Button filterSelection className={filter===3 ? "selec filterBtn" : "filterBtn"} onClick={() => change(3, "Vinho Rosé")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.rose')}</h4></Button>}
              {types.vl && <Button filterSelection className={filter===4 ? "selec filterBtn" : "filterBtn"} onClick={() => change(4, "Vinho Licoroso")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.licor')}</h4></Button>}
              {types.es && <Button filterSelection className={filter===5 ? "selec filterBtn" : "filterBtn"} onClick={() => change(5, "Espumante")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.espumante')}</h4></Button>}
              {types.vp && <Button filterSelection className={filter===6 ? "selec filterBtn" : "filterBtn"} onClick={() => change(6, "Vinho do Porto")}><h4 className={font.nSR}>{t('sidebar:vinhos.tipos.porto')}</h4></Button>}
            </div>
          </div>
        }
        <div className='second-container'>
          <p className={font.aGGD + " menuTitle"}>{t('sidebar:vinhos.title')}</p>
          <div className="menuV">
              <div className="links">
                {t('sidebar:vinhos.docs.links', {returnObjects: true}).map(({link, linkTxt}, i) => (
                  <Link to={link} key={"menuV" + i} partiallyActive={true} activeClassName="red"><h4 className={font.nSBI}>{linkTxt}</h4></Link>
                ))}
                {t('sidebar:vinhos.regionais.links', {returnObjects: true}).map(({link, linkTxt}, i) => (
                  <Link to={link} key={"menuV" + i} partiallyActive={true} activeClassName="red"><h4 className={font.nSBI}>{linkTxt}</h4></Link>
                ))}
                {t('sidebar:vinhos.outros.links', {returnObjects: true}).map(({link, linkTxt}, i) => (
                  <Link to={link} key={"menuV" + i} partiallyActive={true} activeClassName="red"><h4 className={font.nSBI}>{linkTxt}</h4></Link>
                ))}
              </div>
            </div>
        </div>
        <div className='header-footer'>
            <Link to="/" className='logo-link'><img src={!white ? logo : logoBrown} alt="Logo da Saven" className="sidebarLogo"/></Link>
            <div className="segment">
              <div className="social">
                <a href="https://www.linkedin.com/company/luacheiavv" className="socialLink" target="_blank" rel="noreferrer"><img src={link} alt="Logo do LinkedIn" className="logoSmall"/></a>
                <a href="https://www.facebook.com/LuaCheiaSaven" className="socialLink" target="_blank" rel="noreferrer"><img src={face} alt="Logo do Facebook" className="logoSmall"/></a>
                <a href="https://www.instagram.com/luacheia_saven" className="socialLink" target="_blank" rel="noreferrer"><img src={insta} alt="Logo do Instagram" className="logoSmall"/></a>
              </div>
              <div className='address'>
                {t('footer:address.links', {returnObjects: true}).map(({link, linkTxt}, i) => (
                  <a href={link} key={"addressLink" + i} rel="noreferrer" target="_blank"><p className={font.aGGB}>{linkTxt}</p></a>
                ))}
              </div>
            </div>
        </div>
      </Menu>
    </StyledBar>
  )
}

export default Sidebar

const StyledBar = styled(Div100vh)`
    position: fixed;
    right:0;
    z-index:4;
    height:auto !important;

    .header{
      display:flex;
      align-items:center;
      background-color: #fff;
      padding: 15px 15px;
      width: fit-content;
      position: absolute;
      top: 100px;
      right: 0;
      z-index: 9999;
      border:1px solid transparent;
      border-top-left-radius:50px;
      border-bottom-left-radius:50px;

      h3{
        margin-left:auto;
        color: #3e3028;
        letter-spacing: 0.5px;
        font-size: 15px;
      }
    }

    .bm-menu-wrap{
      height: calc(100vh - 50px) !important;
    }

    /* .header::before{
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      background-repeat: repeat;
      height: 10px;
      background-size: 20px 20px;
      background-image: radial-gradient(circle at 10px -5px, transparent 12px, #fff 13px);
    }

    .header::after{
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      background-repeat: repeat;
      height: 15px;
      background-size: 40px 20px;
      background-image: radial-gradient(circle at 10px 15px, crimson 12px, transparent 13px); */

    .bm-menu{
      padding:25px 25px;
      background: #fff;
    }

    .bm-item:focus{
      outline:0;
    }

    .bm-item-list{
      height:100%;
      display:flex;
      flex-direction:column;
      justify-content:space-between;
    }

    .first-container{
      .selector{
        display:flex;
        flex-wrap:wrap;
      }
      button{
        border:1px solid #3e3028;
        border-radius:0;
        margin: 0 15px 15px 0;
        padding: 5px 15px;
        color:#3e3028;

        &.selec{
        background-color:#3e3028;
        color:#fff;
        }

        h4{
          font-size:15px;
        }
      }
    }

    .second-container{
      @media only screen and (max-height: 600px) {
        display:contents !important;
      }

      @media ${device.tabletM}{
        margin-bottom:auto;
        margin-top:50px;
      }
    }

    .menuTitle{
      margin-bottom: 15px;
      direction: ltr;
      font-size:13px;
    }

    .menuV{
      overflow: auto;
      direction: rtl;
    }

    .menuV::-webkit-scrollbar {
      width: 3px;
      background-color: rgba(0, 0, 0, 0.15);
    }
    .menuV::-webkit-scrollbar-thumb {
        height: 6px;
        background-clip: padding-box;
        background-color: #3e3028;
        box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
    .menuV::-webkit-scrollbar-button {
        width: 0;
        height: 0;
        display: none;
    }
    .menuV::-webkit-scrollbar-corner {
        background-color: transparent;
    }



    .links{
        color: ${props => (props.white === "isWhite" ? "#3e3028" : '#fff8f4')};
        direction: ltr;

        @media only screen and (max-height: 600px) {
          padding-left: 5px;
        }
        
        .red{
          color: #fa4f4f;
        }

        h4{
          font-size:22px;
        }
    }

    .logo-link{
      width:fit-content;
      margin-left:auto;
  
      .sidebarLogo{
          width: 100px;
      }
    }

    .segment{
      display: flex;
      justify-content: space-between;
      align-items:flex-end;
      margin-top: 25px;

      .social{
        display:flex;
        flex-wrap:wrap;
      }

      .social a{
        padding: 5px 15px 0 0;
      }

      .address a{
        text-align:right;
      }
    }

    .langGroup{
        display: flex !important;
        width:fit-content;
        color: #3e3028;
        margin-left:auto;

        &:focus{
          outline:0;
        }
    }
`
